import { useStringConstants } from "@/app/hooks/useStringConstants";
import clsx from "clsx";
import { startCase } from "lodash";

const Species: React.FC<{
  speciesId: string;
  className?: string;
}> = (props) => {
  const { dogSpecieTypeId, dogSpecieTypeName, catSpecieTypeName, catSpecieTypeId } = useStringConstants();

  return (
    <span className={clsx(props?.className)}>
      {props?.speciesId === dogSpecieTypeId
        ? startCase(dogSpecieTypeName)
        : props?.speciesId === catSpecieTypeId
          ? startCase(catSpecieTypeName)
          : "Dog"}
    </span>
  );
};

export default Species;
